<template>
  <div class="container-fluid">
    <div><h3>{{taskTypeId ? 'Editar' : 'Cadastrar'}} Tipo de Trabalho</h3></div>
    <form v-on:submit.prevent="storeAndUpdate" class="row">
      <div class="form-group col-md-4">
        <input class="form-control" id="name" v-model="name" ref="name" placeholder="Nome"/>
      </div>
      <div class="col-md-2">
        <money class="form-control" v-model="amount" :disabled="is_fixed_value" />
      </div>
      <div class="form-check col-md-1 d-flex align-items-center gap-1">
        <input class="form-check-input mt-0" type="checkbox" v-model="is_fixed_value" id="is_fixed_value">
        <label class="form-check-label" for="is_fixed_value">Fixo?</label>
      </div>
      <div class="d-flex flex-row gap-2 col-md-2">
        <button type="submit" class="btn btn-success">Salvar</button>
        <button type="button" class="btn btn-secondary" @click="init">Cancelar</button>
      </div>
    </form>
    <ul class="crud-pills nav nav-pills mb-3" id="pills-tab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="active-tab" data-bs-toggle="pill" data-bs-target="#active" type="button"
                role="tab" aria-controls="active" aria-selected="true">Ativas
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="disabled-tab" data-bs-toggle="pill" data-bs-target="#disabled" type="button"
                role="tab" aria-controls="disabled" aria-selected="false">Desativadas
        </button>
      </li>
    </ul>
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Nome</th>
            <th>Valor Hora</th>
            <th>Fixo</th>
            <th width="150px">Ações</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="taskType in taskTypes" :key="taskType.id">
            <td>{{taskType.name}}</td>
            <td>
              <money
                class="form-control hide-input"
                v-model="taskType.amount"
                disabled
              />
            </td>
            <td>{{ taskType.is_fixed_value ? 'Sim' : 'Não' }}</td>
            <td>
              <div class="d-flex flex-row gap-1">
                <button
                  title="Editar"
                  type="button"
                  class="btn btn-outline-primary btn-sm mb-1"
                  @click="loadFormEdit(taskType)"
                >
                  <i class="fas fa-edit"></i>
                </button>
<!--                <button-->
<!--                  title="Excluir"-->
<!--                  type="button"-->
<!--                  class="btn btn-outline-danger btn-sm mb-1"-->
<!--                  @click="destroy(taskType.id)"-->
<!--                >-->
<!--                  <i class="fa fa-trash"></i>-->
<!--                </button>-->
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="tab-pane fade" id="disabled" role="tabpanel" aria-labelledby="disabled-tab">
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Nome</th>
            <th width="150px">Ações</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="taskType in deletedTaskTypes" :key="taskType.id">
            <td><input class="form-control hide-input" v-model="taskType.name" v-on:blur="edit(taskType)"></td>
            <td>
              <button class="btn btn-success" v-on:click="activate(taskType.id)"><i class="fas fa-check"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TaskTypes',
  data() {
    return {
      taskTypeId: null,
      taskTypes: [],
      name: '',
      amount: 0,
      is_fixed_value: false,
      errors: {},
      deletedTaskTypes: {},
    }
  },
  watch: {
    is_fixed_value (val) {
      if (val) {
        this.amount = 0
      }
    }
  },
  mounted() {
    this.deleted()
    this.index()
  },
  methods: {
    init () {
      this.taskTypeId = null
      this.name = '';
      this.amount = 0;
      this.is_fixed_value = false;
      this.errors = {};
    },
    index () {
      axios
        .get('/api/task_types')
        .then(({ data }) => this.taskTypes = data.data)
    },
    storeAndUpdate () {
      if (this.taskTypeId) {
        this.update();
      } else {
        this.store();
      }
    },
    store () {
      axios
        .post('/api/task_types', {
          name: this.name,
          amount: this.amount,
          is_fixed_value: this.is_fixed_value
        })
        .then(() => {
          this.index();
          this.init();
          this.$refs.name.focus()
          this.$toast.success("Registro cadastrado com sucesso!");
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.fail();
        })
    },
    update () {
      axios
        .put(`/api/task_types/${this.taskTypeId}`, {
          name: this.name,
          amount: this.amount,
          is_fixed_value: this.is_fixed_value
        })
        .then(() => {
          this.init();
          this.index();
          this.$refs.name.focus()
          this.$toast.success("Registro alterado com sucesso!")
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.fail()
        })
    },
    loadFormEdit (taskType) {
      this.taskTypeId = taskType.id
      this.name = taskType.name;
      this.amount = taskType.amount;
      this.is_fixed_value = taskType.is_fixed_value;
    },
    fail () {
      let message = ''
      for (let i in this.errors) {
        message = this.errors[i] + '<br />' + message
      }
      this.$swal({
        title: 'Ops...',
        text: message,
        icon: 'error',
        html: message
      });
    },

    destroy(id) {
      this.$confirm(
        {
          message: `Tem certeza que deseja excluir?`,
          button: {
            no: 'Não',
            yes: 'Sim'
          },
          callback: confirm => {
            if (confirm) {
              axios.delete('/api/task_types/' + id)
                .then(() => {
                  this.init();
                  this.index();
                  this.deleted();
                })
            }
          }
        }
      )
    },

    deleted() {
      axios
        .get('/api/task_types/deleted')
        .then((response) => {
          this.deletedTaskTypes = response.data
        })
    },
    activate(id) {
      this.$confirm(
        {
          message: `Tem certeza que deseja reativar?`,
          button: {
            no: 'Não',
            yes: 'Sim'
          },
          callback: confirm => {
            if (confirm) {
              axios.put('/api/task_types/activate/' + id)
                .then(() => {
                  this.index()
                  this.deleted()
                })
            }
          }
        }
      )
    }
  }
}
</script>
